import type { AnySignatureType } from '@/lib/types.ts'

/**
 * Temporary helper to resolve malformed signature types to provide a fix for already filled out protocols
 * Receives the component property and returns an array of signature types
 */
export const resolveSignatureTypes = (signatureTypes: any): AnySignatureType[] => {
	if (!signatureTypes) {
		return []
	}
	
	if (Array.isArray(signatureTypes)) {
		if (signatureTypes[1] === 'bankid') {
			// Malformed
			let newTypes = [ signatureTypes[0] ] // manual
			newTypes[1] = {
				type: 'bankid',
				reset_label: signatureTypes[2],
				success_label: signatureTypes[3],
				error_label: signatureTypes[4],
				choice_button: signatureTypes[5]
			}
			
			return newTypes
		}
		
		return signatureTypes
	}
	
	if (typeof(signatureTypes) === 'object') {
		if (signatureTypes.type) {
			// Malformed
			let newTypes = [ signatureTypes['0'] ]
			newTypes[1] = signatureTypes
			
			return newTypes
		}
		
		if (signatureTypes['0'] || signatureTypes['1']) {
			return Object.values(signatureTypes)
		}
		
		return signatureTypes
	}
	
	return []
}